<template>
  <div class="make-donation">
    <div class="app-form">
      <b-form @submit="onSubmit">
        <p class="go-anon text-right">
          <span v-if="anonMode" @click="beYourself">Be Yourself</span>
          <span v-else @click="beAnonymous">Be Anonymous</span>
        </p>
        <b-form-group
          id="input-group-1"
          class="text-left"
          label="Name:"
          label-for="input-2"
        >
          <b-form-input
            id="input-1"
            v-model="form.firstName"
            required
            :disabled="anonMode"
            placeholder="Enter name"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label="Email:"
          class="text-left"
          label-for="input-1"
          description="We'll never share your email with anyone else."
        >
          <b-form-input
            id="input-2"
            v-model="form.email"
            type="email"
            required
            placeholder="Enter email"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-3"
          class="text-left"
          label="Phone Number:"
          label-for="input-2"
        >
          <b-form-input
            id="input-3"
            v-model="form.phoneNumber"
            required
            placeholder="Enter phone number"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-4"
          class="text-left"
          label="Organization:"
          label-for="input-3"
        >
          <b-form-select
            id="input-4"
            v-model="form.organization"
            :options="[
              { text: 'Select An Organization', value: null },
              ...organizationsOptions
            ]"
            required
          ></b-form-select>
        </b-form-group>

        <b-form-group class="text-left" id="input-group-5">
          <b-form-radio
            v-model="form.walletType"
            name="Donation Type"
            value="shortTerm"
            >One Time Donation</b-form-radio
          >
          <b-form-radio
            v-model="form.walletType"
            name="Donation Type"
            value="longTerm"
            >Recurrent Donation</b-form-radio
          >
        </b-form-group>

        <b-button type="submit" class="app-btn" variant="danger"
          >Submit</b-button
        >
      </b-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required, email, numeric } from "vuelidate/lib/validators";

export default {
  name: "MakeDonationForm",
  data() {
    return {
      form: {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        walletType: null,
        email: ""
      },
      anonMode: false
    };
  },
  validations: {
    form: {
      firstName: { required },
      organization: { required },
      walletType: { required },
      phoneNumber: { numeric },
      email: { email, required }
    }
  },
  computed: {
    ...mapGetters({
      organizationsOptions: ["organization/getOrganizationsOptions"],
      getOrganizationIdFromOption: ["organization/getOrganizationIdFromOption"]
    })
  },
  methods: {
    beYourself() {
      this.anonMode = false;
      this.form.firstName = "";
    },
    beAnonymous() {
      this.anonMode = true;
      this.form.firstName = "Anonymous";
    },
    onSubmit(evt) {
      evt.preventDefault();

      this.form.organizationID = this.getOrganizationIdFromOption(
        this.form.organization
      );
      this.form.lastName = "";
      this.form.countryCode = "";

      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store
          .dispatch("donation/createDonationWallet", this.form, { root: true })
          .then(response => {
            if (response.responsecode === "00") {
              this.$emit("donationWalletCreated");
            }

            this.form = {
              firstName: "",
              lastName: "",
              phoneNumber: "",
              donationType: null,
              email: ""
            };
            this.$v.$reset();
            this.anonMode = false;
          })
          .catch(() => {});
      }
    }
  }
};
</script>

<style scoped></style>
